import { buildHeadersWithWidgetToken } from './build-headers-with-widget-token';

const CORS_PROXY = 'https://cors-proxy.utils.elfsightcdn.com';

export const fetchWithCORSProxy = (
  url: string,
  widgetToken?: string,
  options?: RequestInit
) => {
  const corsUrl = new URL(CORS_PROXY);
  corsUrl.searchParams.append('url', url);

  const { headers: existingHeaders, ...otherOptions } = options ?? {};
  const headers = buildHeadersWithWidgetToken(widgetToken, existingHeaders);

  return fetch(corsUrl, { headers, ...otherOptions });
};
